// @flow

import React from 'react';

import type { SessionContextType } from '../types/session.js.flow';

const defaultState = {
  loading: false,
  error: null,
  session: null,
  login: () => Promise.resolve(1),
  remoteLogin: () => Promise.resolve(1),
  logout: () => undefined,
};

const Context = React.createContext<SessionContextType>(defaultState);
const { Provider, Consumer } = Context;

export { Context, Provider, Consumer, defaultState };
